import { Injectable } from '@angular/core';
import type { PixiGameApp } from '@render/pixi-app';
import type { SimState } from '@sim/core/state';

/**
 * Loads the render layer on demand. `@render/pixi-app` is the only thing in `src/app`'s graph that
 * reaches pixi, so importing it dynamically keeps roughly 330 kB — pixi plus everything under
 * `src/render` that draws with it — out of the initial chunk. The canvas mounts from
 * `afterNextRender`, which already awaits this, so nothing else has to absorb the wait.
 */
@Injectable({ providedIn: 'root' })
export class PixiAppFactory {
  async create(host: HTMLElement, initialState: SimState): Promise<PixiGameApp> {
    const { PixiGameApp } = await import('@render/pixi-app');
    return PixiGameApp.create(host, initialState);
  }
}
